import { render, staticRenderFns } from "./editPageTemplate.vue?vue&type=template&id=5db21bbe&scoped=true&"
import script from "./editPageTemplate.vue?vue&type=script&lang=js&"
export * from "./editPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db21bbe",
  null
  
)

export default component.exports